export const DateTimeFormats = {
  LocalDate: "yyyy-MM-dd",
  LocalTime: "HH:mm:ss",
};
